<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorGenderBalance.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorGenderBalance.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorGenderBalance.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorGenderBalance.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorGenderBalance.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorGenderBalance.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.genderBalance.hero.title')"
      :lead="$t('investor.genderBalance.hero.lead')"
      image="/images/investor/hero/gender_banner.png"
    />

    <FileList
      :request-id="'rownowage-plci'"
      :show-title="false"
    />
  </div>
</template>
